import once from 'lodash.once';
WB.Utility = WB.Utility || {};

WB.Utility.GlobalClassUtility = function() {

    this.classes = [];

    this.initializeGlobalClasses = once(function() {
        document.querySelector('html').setAttribute('class', this.classes.concat(['ng-scope', 'ng-app']).join(' '));
    });

    this.clear = function() {
        this.classes.length = 0;
    };

    this.addClasses = function(a) {
        a.forEach(function(a1) { this.addClass(a1); }.bind(this));
    };

    this.addClass = function(c) {
        if (this.classes.indexOf(c) !== -1) { return; }
        this.classes.push(c);
    };

    this.removeClasses = function(a) {
        a.forEach(function(a1) { this.removeClass(a1); }.bind(this));
    };

    this.removeClass = function(c) {
        var index = this.classes.indexOf(c);
        if (index !== -1) {
            this.classes.splice(index, 1);
        }
    };

    this.toggleClass = function(c, add) {
        add ? this.addClass(c) : this.removeClass(c);
    };

};
WB.Utility.GlobalClassUtility.$inject = [];

WB.Core.service('GlobalClassUtility', WB.Utility.GlobalClassUtility);
